import { Typography } from "@mui/material";
import { useRef } from "react";
import { Row } from "v2/components/base/Flex/ui";

const TabsGroupUI = ({
  tabs,
  selectedTab,
  handleTabChange,
  tabColor = "#fff",
  ...props
}: {
  tabs: string[];
  selectedTab: number;
  handleTabChange: (tab: number) => void;
  tabColor: string;
} & any) => {
  const { sx, ...rest } = props;
  const padding = "5px";

  return (
    <Row
      sx={{
        position: "relative",
        borderRadius: "32px",
        border: "1px solid #FFFFFF",
        padding: padding,
        ...sx,
      }}
      {...rest}>
      <Row
        type="cc"
        sx={{
          position: "absolute",
          top: padding,
          left: `calc(${selectedTab} * (100% / ${tabs.length}) + ${padding})`,
          width: `calc(100% / ${tabs.length} - ${padding} - ${padding})`,
          height: `calc(100% - ${padding} - ${padding})`,
          background: tabColor,
          borderRadius: "32px",
          transition: "left 0.3s cubic-bezier(.4,0,.2,1)",
          zIndex: 1,
        }}>
        <Typography variant="mobile-action-s" color="text.btn-dark">
          {tabs[selectedTab]}
        </Typography>
      </Row>
      {tabs.map((tab: string, index: number) => (
        <Row
          key={tab}
          type="cc"
          sx={{
            width: `calc(100% / ${tabs.length})`,
            height: sx?.height ? `calc(${sx.height} - ${padding} - ${padding})` : "45px",
            padding: "9.5px",
            cursor: "pointer",
          }}
          onClick={() => handleTabChange(index)}>
          <Typography
            variant="mobile-action-s"
            color="text.primary"
            sx={{
              opacity: selectedTab === index ? 0 : 1,
              transition: "opacity .8s",
            }}>
            {tab}
          </Typography>
        </Row>
      ))}
    </Row>
  );
};

export default TabsGroupUI;
